<template>
  <div class="bg-container">
    <div class="login">
      <div class="hero">
        <button type="button" class="back" @click="back()">
          <van-icon name="arrow-left" color="#8a63c9" />
        </button>
        <div class="logo">
          <img src="/img/login/logo2.png?v=2" alt="">
        </div>
      </div>
      <div class="sheet">
        <div class="wrap">
          <div class="input_wrap">
            <van-icon name="contact-o" size="16" color="#b79cec"></van-icon>
            <input type="text" :placeholder="$t('auth.username_place')" v-model="username">
          </div>
          <div class="input_wrap">
            <img src="/img/login/password.png" alt="" style="width: 1.00rem; height: 1.00rem;">
            <input :placeholder="$t('auth.pwd_place')" v-model="password" :type="pwdType == 1 ? 'password' : 'text'">
            <van-icon :name="pwdType == 0 ? 'eye-o' : 'closed-eye'" color="#b79cec" size="24" @click="pwdType = pwdType == 1 ? 0 : 1"></van-icon>
          </div>
          <div class="input_wrap">
            <img src="/img/login/code.png" alt="" style="width: 1.00rem; height: 1.00rem;">
            <input type="text" :placeholder="$t('auth.invite_code_place')" v-model="code">
          </div>
        </div>
        <div class="button" @click="doRegister()">{{$t("auth.register")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { connectWs } from "@/common/ws";
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pwdType: 1,
      checked: true,
      username: '',
      code: '',
      lang: 'en_us',
      password: this.inputValue,
      passwordType: 'password',
    };
  },
  mounted(){
    
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back(){
      return window.history.back();
    },
    doRegister() {
      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if(this.code === "" || this.code === null || this.code === undefined){
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      if(!this.checked){
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }
      this.$http({
        method: 'post',
        data:{
          username:this.username,
          password:this.password,
          code:this.code
        },
        url: 'member_register'
      }).then(res=>{
          if(res.code === 200){
            this.$toast.success(res.msg);
            localStorage.setItem('token',res.data)
            connectWs() // 注册成功后建立全局 WS
            this.$router.push("Mine")
          }else {
            this.$toast.fail(res.msg);
          }
      })
    }
  },
  created() {
    if(localStorage.getItem('token')){
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import '~@/assets/css/theme.less';

.bg-container {
  background: @bg-soft;
  height: 100%;
}
.login {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background: @bg-soft;
}

.hero {
  position: relative;
  flex-shrink: 0;
  height: 16.5rem;
  background:
    linear-gradient(180deg, rgba(74, 40, 90, 0.05) 40%, rgba(255, 214, 228, 0.28) 100%),
    url('/public/img/login/bg2.png') no-repeat center top / cover;
  border-radius: 0 0 2.4rem 2.4rem;
}

.back {
  position: absolute;
  top: 0.9rem;
  left: 0.9rem;
  z-index: 10;
  width: 2.1rem;
  height: 2.1rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 0.15rem 0.5rem rgba(80, 40, 90, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  .van-icon {
    font-size: 1.15rem;
  }
}

.logo {
  position: absolute;
  left: 1.2rem;
  bottom: 2.2rem;
  width: 16.8rem;
  max-width: calc(100% - 2.4rem);
  img{
    display: block;
    width: 100%;
    height: auto;
    aspect-ratio: 1462 / 482;
    border-radius: 0.45rem;
    filter: drop-shadow(0 0.25rem 0.6rem rgba(80, 40, 90, 0.35));
  }
}

.sheet {
  position: relative;
  z-index: 2;
  flex: 1;
  margin-top: -1.8rem;
  padding: 4.5rem 1.35rem 1.6rem;
  background: #fffafc;
  border-radius: 1.8rem 1.8rem 0 0;
  box-shadow: 0 -0.45rem 1.4rem rgba(183, 156, 236, 0.18);
}

.wrap{
  .input_wrap{
    width: 100%;
    height: 3.2rem;
    margin: 0 0 0.75rem;
    border-radius: 0.9rem;
    overflow: hidden;
    background: #fff;
    border: 1px solid #f0e2f2;
    box-shadow: 0 0.15rem 0.5rem rgba(183, 156, 236, 0.08);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 1rem;
    input{
      flex: 1;
      height: 100%;
      border: none;
      background: none;
      outline: none;
      text-align: left;
      font-size: .93333rem;
      padding-left: 0.75rem;
      color: @text-title;
      &::placeholder {
        color: @text-sub;
      }
    }
  }
}

.button{
  width: 100%;
  background: @grad-primary;
  box-shadow: @shadow-pink;
  font-size: 1.08rem;
  font-weight: 600;
  letter-spacing: 0.06rem;
  color: #fff;
  text-align: center;
  height: 3rem;
  line-height: 3rem;
  border-radius: 0.9rem;
  margin: 0.55rem 0 0;
}
</style>
